module.exports = __webpack_public_path__ + "static/media/favicon.435897c0.ico";